// owner: social-graph domain agent (W2 invites)
import { z } from 'zod';
import { EmailSchema, EpochMsSchema, PaginationQuerySchema, UlidSchema, paginated } from './common';

export const InviteStatusSchema = z.enum(['pending', 'accepted', 'revoked', 'expired']);
export type InviteStatus = z.infer<typeof InviteStatusSchema>;

export const InviteCreateSchema = z.object({
  /** Omitted: a plain shareable link. Present: the invite is emailed to this address too. */
  email: EmailSchema.optional(),
});
export type InviteCreate = z.infer<typeof InviteCreateSchema>;

/** Returned only from POST /invites: the only place the raw token (embedded in `url`) ever appears. */
export const InviteCreateResponseSchema = z.object({
  id: UlidSchema,
  url: z.string(),
  email: z.string().nullable(),
  expiresAt: EpochMsSchema,
  status: InviteStatusSchema,
});
export type InviteCreateResponse = z.infer<typeof InviteCreateResponseSchema>;

/** List item: never includes the token/url. */
export const InviteSchema = z.object({
  id: UlidSchema,
  email: z.string().nullable(),
  status: InviteStatusSchema,
  createdAt: EpochMsSchema,
  expiresAt: EpochMsSchema,
  acceptedAt: EpochMsSchema.nullable(),
});
export type Invite = z.infer<typeof InviteSchema>;
export const InviteListSchema = paginated(InviteSchema);
export const InviteListQuerySchema = PaginationQuerySchema;

export const InviteIdParamsSchema = z.object({ id: UlidSchema });

export const InviteAcceptSchema = z.object({ token: z.string().trim().min(1).max(200) });
export type InviteAccept = z.infer<typeof InviteAcceptSchema>;

export const InviteAcceptResponseSchema = z.object({
  accepted: z.literal(true),
  inviterId: UlidSchema,
});
export type InviteAcceptResponse = z.infer<typeof InviteAcceptResponseSchema>;
